module.exports = __webpack_public_path__ + "static/media/Home.eeb40d8e.png";